import { NavLink } from "react-router-dom";
import { House, Barbell, ForkKnife, Notebook, ChatCircle, ChartLine } from "@phosphor-icons/react";
import { APP_VERSION } from "@/version";

/**
 * MobileBottomNav — persistent bottom tab bar for client users on mobile.
 * Hidden on md+ screens (desktop uses the sidebar).
 * Every inner page inherits this so clients never have to hunt for navigation
 * or exit the PWA to get back to their dashboard.
 */
const TABS = [
  { to: "/app", label: "Today", icon: House, end: true, testid: "mobilenav-today" },
  { to: "/app/program", label: "Program", icon: Barbell, testid: "mobilenav-program" },
  { to: "/app/meals", label: "Meals", icon: ForkKnife, testid: "mobilenav-meals" },
  { to: "/app/stats", label: "Stats", icon: ChartLine, testid: "mobilenav-stats" },
  { to: "/app/logs", label: "Logs", icon: Notebook, testid: "mobilenav-logs" },
  { to: "/app/messages", label: "Coach", icon: ChatCircle, testid: "mobilenav-coach" },
];

export default function MobileBottomNav() {
  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-30 bg-[#0A0A0A] border-t border-[#262626] pb-safe"
      data-testid="mobile-bottom-nav"
      // Respect iOS safe area (home indicator strip)
      style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <div className="grid grid-cols-6">
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={t.testid}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-2.5 text-[9px] font-manrope uppercase tracking-[0.08em] transition-colors ${
                  isActive
                    ? "text-white bg-[#FF3333]/10 border-t-2 border-[#FF3333] -mt-[2px]"
                    : "text-zinc-500 border-t-2 border-transparent hover:text-white"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={18} weight={isActive ? "fill" : "regular"} />
                  <span>{t.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </div>
      {/* Tiny build tag so we can confirm which version a device is actually running.
          Critical for diagnosing iOS PWA cache-stuck reports from clients. */}
      <div
        className="text-center text-[9px] font-manrope uppercase tracking-[0.15em] text-zinc-600 pb-1"
        data-testid="app-version-tag"
      >
        v{APP_VERSION}
      </div>
    </nav>
  );
}
